import { connect } from 'react-redux';
import ConnectPage from './ConnectPage';
import { connectIntegrator } from './Connect.saga';

const mapDispatchToProps = {
  handleSubmit: (formValues, formAsyncFns) => connectIntegrator({ ...formValues }, formAsyncFns),
};
export default connect(null, mapDispatchToProps)(ConnectPage);
